import gql from 'graphql-tag';

export const setBayOutOfServiceMutation = gql`
    mutation parklioSetBayOutOfService($bayId: ID!, $reason: OverrideReason!) {
        parklioSetBayOutOfService(bayId: $bayId, reason: $reason) {
            bayId
            status
            affectedBookings {
                bookingId
                guestName
                startDay
                endDay
                plate
            }
        }
    }
`;

export const returnBayToServiceMutation = gql`
    mutation parklioReturnBayToService($bayId: ID!) {
        parklioReturnBayToService(bayId: $bayId) {
            bayId
            status
        }
    }
`;
